import createSagaMiddleware, { Task } from 'redux-saga';
import { rootSaga } from './saga';
import { configureStore, Store } from '@reduxjs/toolkit';
import { IHomeReducer, productReducer } from './Product/reducer';
import { alertReducer } from './Alert/reducer';
import { adminReducer } from './AdminPanel/reducer';
import { authReducer } from './Auth/reducer';
import { brandsReducer } from './Brands/reducer';
import { CollectionsReducer } from './Collections/reducer';
import { ContactUsReducer } from './ContactUs/reducer';
import { instaMediaReducer } from './InstaMedia/reducer';
import { loadingReducer } from './Loading/reducer';
import { localeReducer } from './Locale/reducer';
import { modelReducer } from './Model/reducer';
import { offerReducer } from './Offer/reducer';
import { currencyReducer } from './SelectedCurrency/reducer';
import { selectedLangReducer } from './SelectedLanguage/reducer';
import { serviceOrderReducer } from './ServiceOrder/reducer';

export interface InitialStoreState {
  products?: IHomeReducer;
  alert?: any;
  brands?: any;
  instaMedia?: any;
  admin?: any;
  offers?: any;
  models?: any;
  auth?: any;
  loading?: any;
  serviceOrder?: any;
  contactUs?: any;
  selectedLang?: any;
  locale?: any;
  currency?: any;
  collections?: any;
}

export interface SagaStore extends Store {
  sagaTask?: Task;
}

export const makeStore = (initialState?: InitialStoreState) => {
  const sagaMiddleware = createSagaMiddleware();

  const middleware = [sagaMiddleware];

  // Automatically adds the thunk middleware and the Redux DevTools extension
  const store = configureStore({
    // Automatically calls `combineReducers`
    reducer: {
      products: productReducer,
      alert: alertReducer,
      brands: brandsReducer,
      instaMedia: instaMediaReducer,
      admin: adminReducer,
      offers: offerReducer,
      models: modelReducer,
      auth: authReducer,
      loading: loadingReducer,
      serviceOrder: serviceOrderReducer,
      contactUs: ContactUsReducer,
      selectedLang: selectedLangReducer,
      locale: localeReducer,
      currency: currencyReducer,
      collections: CollectionsReducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(middleware),
    preloadedState: initialState,
  });

  // 3: Run your sagas on server
  (store as SagaStore).sagaTask = sagaMiddleware.run(rootSaga);

  return store;
};

// Infer the type of makeStore
export type AppStore = ReturnType<typeof makeStore>;

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<AppStore['getState']>;
export type AppDispatch = AppStore['dispatch'];
